import { Suspense, useSyncExternalStore } from 'react';
import { MeRuntime } from '@/features/me';
import { CallsHost } from '@/features/calls';
import { ChatinfoRuntime } from '@/features/chatinfo';
import { ErrorBoundary } from './ErrorBoundary';
import { featureRuntimeStore, registerFeatureRuntime, type FeatureRuntimePhase } from './runtimes';

// These public hosts predate the registry. Keep their registration here until their owners adopt the seam.
registerFeatureRuntime('me', MeRuntime);
registerFeatureRuntime('calls', CallsHost);
registerFeatureRuntime('chatinfo.cleanup', ChatinfoRuntime, { phase: 'services' });

export function FeatureRuntimes({ phase }: { phase: FeatureRuntimePhase }) {
  const entries = useSyncExternalStore(featureRuntimeStore.subscribe, featureRuntimeStore.getSnapshot);
  return <>{entries.filter(entry => entry.phase === phase).map(({ id, component: Runtime }) =>
    <ErrorBoundary key={id}><Suspense fallback={null}><Runtime /></Suspense></ErrorBoundary>)}</>;
}
